// AgentDetailsModal.jsx
import { Flex, Modal } from "antd";
import "./AgentDetailsModal.scss";
import GaugeChart from "../../../Reuseable/GaugeChart/GaugeChart";
import GreenSmile from "../../../assets/Icons/GreenSmile.svg"
import AgentMapWithPopup from "../AgentDetailsComp/AgentMapWithPopup";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFieldAgentCaseDetails } from "../../../assets/api/allocation";
import moment from "moment";

const AgentDetailsModal = ({ open, onClose, agent }) => {
  const { token } = useSelector(state => state.auth);
  const [assignedCase, setAssignedCase] = useState({
    loading: false,
    data: {}
  });
  const { feedback_details, case_details } = assignedCase?.data || {}



  useEffect(() => {
    if (!open) return;
    getCaseInfo()
  }, [token, agent])

  const getCaseInfo = async () => {
    try {
      setAssignedCase((prev) => ({
        ...prev,
        loading: true,
        data: {}
      }))
      const res = await getFieldAgentCaseDetails(token, agent?.id);

      setAssignedCase((prev) => ({
        ...prev,
        loading: false,
        data: res?.data?.data || {}
      }))
    } catch (error) {
      setAssignedCase((prev) => ({
        ...prev,
        loading: false,
        data: {}
      }))
    }
  }

  console.log(assignedCase, 'assignedCaseassignedCaseassignedCase');

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      width={1060}
      className="agentModal"
    >
      <h3 className="modalTitle">Visit Details</h3>

      <AgentMapWithPopup data={{}} data2={assignedCase} isSingle={true} />

      <Flex className="visit-report">
        <p className="headline">Field Visit Report – Loan Collection Attempt</p>
        <Flex className="visit-report-box">
          <Flex className="report-detail">
            <Flex className="inner-box">
              <Flex className="label">Date and Time of Visit</Flex>
              <Flex className="description">{case_details?.visit_datetime ? moment.utc(case_details?.visit_datetime).format("MMMM DD, YYYY | hh:mm A") : '--'}</Flex>
            </Flex>
            <Flex className="inner-box">
              <Flex className="label">Agent Name</Flex>
              <Flex className="description">{case_details?.agent_name || '--'}</Flex>
            </Flex>
            <Flex className="inner-box">
              <Flex className="label">Loan Account No.</Flex>
              <Flex className="description">{case_details?.loan_no || '--'}</Flex>
            </Flex>
          </Flex>
          <Flex className="report-detail">
            <Flex className="inner-box">
              <Flex className="label">Customer Name</Flex>
              <Flex className="description">{case_details?.customer_name || '--'}</Flex>
            </Flex>
            <Flex className="inner-box">
              <Flex className="label">Loan Type</Flex>
              <Flex className="description">{case_details?.loan_type || '--'}</Flex>
            </Flex>
            <Flex className="inner-box">
              <Flex className="label">Bank/NBFC</Flex>
              <Flex className="description">{case_details?.bank_name}</Flex>
            </Flex>
          </Flex>
          <Flex className="report-detail">
            <Flex className="inner-box">
              <Flex className="label">{case_details?.bank_name} Bank</Flex>
              <Flex className="description">
                {case_details?.customer_address || '--'}
              </Flex>
            </Flex>
            <Flex className="inner-box">
              <Flex className="label">City</Flex>
              <Flex className="description">{case_details?.city || '--'}</Flex>
            </Flex>
            <Flex className="inner-box">
              <Flex className="label">Pin code</Flex>
              <Flex className="description">{case_details?.pincode || '--'}</Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex className="visit-description">
          <Flex className="visit-outcome">
            <p>Visit Outcome</p>
            <p>
              {feedback_details?.remark || '--'}
            </p>
          </Flex>
          <Flex className="visit-outcome">
            <p>Next Action Recommended</p>
            <Flex className="pointers">
              <p className="bullet-paragraph">
                Attempt second visit during evening hours or weekend.
              </p>
              <p className="bullet-paragraph">
                Try contacting the customer on mobile to confirm availability.
              </p>
              <p className="bullet-paragraph">
                Escalate to supervisor if no response after repeated visits.
              </p>
            </Flex>
          </Flex>
          <Flex className="visit-report-footer">
            <Flex className="footer">
              <p>Sentiment</p>
              <button><img src={GreenSmile} alt="GreenSmile" />Positive</button>
            </Flex>
            <Flex className="footer">
              <p>
                Predicted <br /> Disposition
              </p>
              <Flex className="data-and-graph">
                <Flex className="data">
                  <p className="data-head">May respond in evening</p>
                  <h1>78%</h1>
                </Flex>
                <GaugeChart />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default AgentDetailsModal;
